<template>
  <div
    class="selected-tickets-list scrollbar-hidden mr-auto flex w-full max-w-[calc(100%_-_250px)] md:-mx-4 md:w-auto md:max-w-none md:overflow-x-scroll md:px-4"
  >
    <ul class="flex w-full md:!w-full">
      <SelectedTicketsListItem
        v-for="(ticket, index) in groupedTickets"
        :key="`${ticket.sectorId}${ticket.tariffId}+${index}`"
        :item="ticket"
        :style="{ width: `${ticketLength}%` }"
        class="max-w-[180px] xl:max-w-[150px] tablet:max-w-[135px] md:mr-3 md:!w-auto md:pb-0.5 md:last:mr-0"
        @delete-ticket="deleteTicket(ticket, ticket.realIndex || index)"
      />
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { TicketReduced } from '@/models'

const props = defineProps({
  groupedTickets: {
    required: true,
    type: Array as PropType<TicketReduced[]>,
  },
})

const { deleteTicket } = useTicketStore()

const ticketLength = computed(() => {
  const ticketsLength = props.groupedTickets.length
  // уравнение расчета коэффициента было получено имперически
  // с линейной аппроксимацией
  // показывает как менять ширину карточек при изменении их кол-ва
  const k = 0.35 * ticketsLength - 1.63

  // если билетов 5 и меньше, они могут не залезать
  if (ticketsLength <= 5) return 100 / (ticketsLength + 0.4)

  // далее вводим поправочный коэффициент
  return 100 / (ticketsLength + k)
})
</script>
